"use client";
import { calculateLumpsumValue } from "@/utils/allCalculators";
import React from "react";
import { useLoginModal } from "@/utils/useLoginModal";

type TableRow = {
  label: string;
  values: { [key: string]: string };
};

type RollingReturnsTableProps = {
  data: TableRow[];
};

const headers = ["Period", "1Y", "2Y", "3Y", "5Y"];

const RollingReturnsTable = React.memo(function RollingReturnsTable({ data }: RollingReturnsTableProps) {
  const sipAmount = 50000;

  const getYears = (period: string): number => {
    return parseInt(period.replace("Y", ""));
  };

  const { isLoggedIn } = useLoginModal();

  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <div className="font-semibold text-primaryBlack text-xs">
          Value of <span className="font-bold italic text-primaryBlue">₹ 50,000</span> as Lumpsum investment
        </div>
        <p className="hidden sm:block text-xs text-[#6E6E73] font-medium">*All Returns are Annualized</p>
      </div>
      <div
        className={`rounded-4xl scrollbar-xs text-sm text-primaryBlack border-none relative ${isLoggedIn ? "overflow-x-auto" : "overflow-x-hidden"}`}
      >
        <table className="w-full">
          <thead>
            <tr className="text-[#444444] font-semibold">
              {headers.map((header, index) => (
                <th
                  key={index}
                  className="text-center first:text-left py-2.5 px-3 sm:py-3 sm:px-4 border-b border-[#E9E9EB]"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIdx) => (
              <tr key={rowIdx} className="border-b last:border-none border-[#E9E9EB]">
                <td className="py-2.5 px-3 sm:py-3 sm:px-4 text-[#343434]">{row.label}</td>
                {headers.slice(1).map((period) => {
                  if (!isLoggedIn) {
                    return (
                      <td key={period} className="text-center py-2.5 px-3 sm:py-3 sm:px-4 font-medium">
                        <div className="text-[#949494]">00</div>
                      </td>
                    );
                  }
                  const percentString = row.values[period];
                  const years = getYears(period);

                  if (percentString == "NA" || percentString == "-" || !percentString) {
                    return (
                      <td key={period} className="text-center py-2.5 px-3 sm:py-3 sm:px-4 font-medium">
                        <span className="text-[#949494]">NA</span>
                      </td>
                    );
                  }

                  const annualReturn = parseFloat(percentString);
                  const calculatedValue = calculateLumpsumValue(sipAmount, annualReturn, years);
                  const isNegative = annualReturn < 0;

                  return (
                    <td key={period} className="text-center py-2.5 px-3 sm:py-3 sm:px-4 font-medium">
                      <div className="text-primaryBlack">
                        ₹{calculatedValue.toLocaleString()}
                        <span
                          className={`flex items-center gap-1 flex-nowrap justify-center ${isNegative ? "text-red-700" : "text-[#2C841C]"}`}
                        >
                          <i
                            className={`inline-block align-middle w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent ${isNegative ? "border-t-[5px] border-t-red-700" : "border-b-[5px] border-b-[#2C841C]"}`}
                          />
                          {annualReturn.toFixed(2)}%
                        </span>
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
});

export default RollingReturnsTable;
